import { Component, Emit, Inject, Prop, Watch } from 'vue-property-decorator';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import InstitucionesRegistrarF1SnpComponent from '@/entities/snp/solicitud/formato_1/institucionesF1/instituciones-registrar-f1-snp.vue';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import { InstitucionConSedeSeleccion, InstitucionSnp, SedeSnp } from '@/shared/model/snp/instituciones-snp.model';
import { BvTableFieldArray } from 'bootstrap-vue';
import { Programa } from '@/shared/model/programa.model';
import { CaracteristicaPrograma } from '@/entities/snp/administracion/programas/programa.model';
import { IUsuarioRol, UsuarioRol } from '@/shared/model/usuarioRol';
import PersonalBecaService from '@/entities/seguimiento/personal-beca.service';
import { RolAutoridad } from '@/shared/model/enumerations/rol-autoridad.model';

@Component({
  components: {
    'instituciones-registrar-f1-snp': InstitucionesRegistrarF1SnpComponent,
  },
})
export default class InstitucionesF1Snp extends ApeironComponent {
  @Inject('personalBecaService') private readonly personalBecaService!: () => PersonalBecaService;

  @Prop({ required: true })
  public solucion!: Solucion;

  @Prop({ required: true })
  public solicitud!: Solicitud;

  public caracteristica: CaracteristicaPrograma = {};

  public filtroInstituciones = '';
  public readonly perPage = 15;
  public currentPage = 1;
  public institucionesDelPrograma: Array<InstitucionSnp> = [];
  public institucionesFiltradas: Array<InstitucionSnp> = [];
  public usuarios: Array<IUsuarioRol> = [];

  public readonly fieldsSedes: BvTableFieldArray = [
    {
      key: 'reniecytDependencia',
      label: this.$t('apeironGwApp.institucionesF1Snp.campos.noDeRegistro').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'claveSede',
      label: this.$t('apeironGwApp.institucionesF1Snp.campos.claveSede').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'sede',
      label: this.$t('apeironGwApp.institucionesF1Snp.campos.sede').toString(),
      class: 'text-left',
      thStyle: { width: '20rem' },
    },
    {
      key: 'claveDependencia',
      label: this.$t('apeironGwApp.institucionesF1Snp.campos.claveDependencia').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'nombreDependencia',
      label: this.$t('apeironGwApp.institucionesF1Snp.campos.dependencia').toString(),
      class: 'text-left',
      thStyle: { width: '20rem' },
    },
    {
      key: 'postulante',
      label: this.$t('apeironGwApp.institucionesF1Snp.mensajes.postulante').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'entidadFederativa',
      label: this.$t('apeironGwApp.institucionesF1Snp.campos.entidadFederativa').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'acciones',
      label: this.$t('apeironGwApp.institucionesF1Snp.campos.acciones').toString(),
      class: 'text-center btn-acciones',
      thStyle: { width: '6rem' },
    },
  ];

  public mostrarModalEliminar = false;
  public institucionEliminar: InstitucionSnp = {};
  public sedeEliminar: SedeSnp = {};

  public created(): void {
    this.iniciarComponente();
  }

  @Watch('solicitud', { immediate: true })
  public watchSolicitud(): void {
    this.caracteristica = <CaracteristicaPrograma>this.solicitud.programa?.caracteristica;
  }

  public iniciarComponente(): void {
    this.institucionesDelPrograma = (this.solicitud?.instituciones ?? []).map(InstitucionSnp.fromObject);
    this.buscarEnInstituciones();
  }

  public buscarEnInstituciones(): void {
    this.institucionesFiltradas = [];
    this.institucionesDelPrograma.forEach(institucion => {
      if (this.filtroInstituciones) {
        if (
          institucion.claveInstitucion?.toLowerCase().includes(this.filtroInstituciones.toLowerCase()) ||
          institucion.nombreInstitucion?.toLowerCase().includes(this.filtroInstituciones.toLowerCase()) ||
          institucion.sector?.toLowerCase().includes(this.filtroInstituciones.toLowerCase()) ||
          institucion.entidadFederativa?.toLowerCase().includes(this.filtroInstituciones.toLowerCase()) ||
          institucion.municipio?.toLowerCase().includes(this.filtroInstituciones.toLowerCase()) ||
          institucion.reniecyt?.toLowerCase().includes(this.filtroInstituciones.toLowerCase())
        ) {
          this.institucionesFiltradas.push(institucion);
        }
      } else {
        this.institucionesFiltradas.push(institucion);
      }
    });
  }

  public manejaSeleccionInstitucion(seleccion: InstitucionConSedeSeleccion): void {
    if (!this.validarGuardado(seleccion)) {
      return;
    }
    this.asignaCoordinadoresInstitucion(seleccion);
  }

  /**
   * Valida las condiciones de guardado de las instituciones.
   * Opción         Permite:  Instituciones   Sedes    Dependencias   Validar
   * 'INTERINSTITUCIONAL'       Si              Si         Si           N/A
   * 'MULTISEDE'                No              Si         Si           Institución
   * 'MULTIDEPENDENCIA'         No              No         Si           Sede
   * 'DOBLE TITULACIÓN'         No              No         No           Dependencia
   * 'UNISEDE'                  No              No         No           Dependencia
   * @param seleccion
   * @returns
   */
  private validarGuardado(seleccion: InstitucionConSedeSeleccion): boolean {
    const cveCaracteristicaPrograma: string = this.caracteristica.cveCaracteristica ?? '---';
    const caracteristicaPrograma: string = this.caracteristica.caracteristica ?? '';
    const clavesInstituciones: Array<string | undefined> = [];
    const clavesSedes: Array<string | undefined> = [];
    const clavesDependencias: Array<string | undefined> = [];

    this.institucionesDelPrograma.forEach(institucion => {
      clavesInstituciones.push(institucion.claveInstitucion);
      (institucion.sedes ?? []).forEach(sede => {
        clavesSedes.push(sede.claveSede);
        clavesDependencias.push(sede.claveDependencia);
      });
    });

    if (['DOBTIT', 'UNISD'].includes(cveCaracteristicaPrograma)) {
      // Validar Dependencia
      if (
        (clavesDependencias.length > 1 || !clavesDependencias.includes(seleccion.sede?.claveDependencia)) &&
        clavesDependencias.length > 0
      ) {
        this.alertService().showWarning(
          this,
          this.$t('apeironGwApp.institucionesF1Snp.mensajes.validacionFalladaGuardadoUnidependencia', {
            caracteristica: caracteristicaPrograma,
          }).toString()
        );
        return false;
      }
    }

    if (['MULTDP'].includes(cveCaracteristicaPrograma)) {
      // Validar sede
      if ((clavesSedes.length > 1 || !clavesSedes.includes(seleccion.sede?.claveSede)) && clavesSedes.length > 0) {
        this.alertService().showWarning(
          this,
          this.$t('apeironGwApp.institucionesF1Snp.mensajes.validacionFalladaGuardadoUnisede', {
            caracteristica: caracteristicaPrograma,
          }).toString()
        );
        return false;
      }
    }

    if (['MULTSD'].includes(cveCaracteristicaPrograma)) {
      // Validar institución
      if (
        (clavesInstituciones.length > 1 || !clavesInstituciones.includes(seleccion.institucion?.claveInstitucion)) &&
        clavesInstituciones.length > 0
      ) {
        this.alertService().showWarning(
          this,
          this.$t('apeironGwApp.institucionesF1Snp.mensajes.validacionFalladaGuardadoUniinstitucion', {
            caracteristica: caracteristicaPrograma,
          }).toString()
        );
        return false;
      }
    }

    return true;
  }

  private asignaCoordinadoresInstitucion(seleccion: InstitucionConSedeSeleccion): void {
    this.usuarios = this.solicitud.usuarios || [];
    this.personalBecaService()
      .obtenerPersonalBecasPorInstitucinYRoles(seleccion.institucion?.claveInstitucion ?? '', [
        RolAutoridad.COORDINADOR_INSTITUCIONAL,
        RolAutoridad.ASISTENTE_COORDINADOR_INSTITUCIONAL,
      ])
      .then(res => {
        const usuarios: Array<IUsuarioRol> = res.data.map(personalBeca => UsuarioRol.fromObject(personalBeca));
        const coordinador = usuarios.find(usuario => usuario.rol === RolAutoridad.COORDINADOR_INSTITUCIONAL);
        if (!coordinador) {
          this.alertService().showWarning(
            this,
            this.$t('apeironGwApp.institucionesF1Snp.mensajes.validacionFalladaGuardadoCoordinador', {
              institucion: seleccion.institucion?.nombreInstitucion ?? '',
            }).toString()
          );
          return;
        }
        const usuariosNuevos = usuarios.filter(usuario => !this.usuarios.some(u => u.cvu === usuario.cvu));
        this.emitirActualizacion(this.procesaGuardadoDeSeleccion(seleccion), this.usuarios.concat(usuariosNuevos));
      })
      .catch(err => {
        this.alertService().showError(
          this,
          this.$t('apeironGwApp.institucionesF1Snp.mensajes.errorValidacionGuardadoCoordinador', {
            institucion: seleccion.institucion?.nombreInstitucion ?? '',
          }).toString()
        );
        return;
      });
  }

  private procesaGuardadoDeSeleccion(seleccion: InstitucionConSedeSeleccion): Array<InstitucionSnp> {
    const esPostulante: boolean = this.institucionesDelPrograma.length < 1;
    const institucionesFinales: Array<InstitucionSnp> = this.institucionesDelPrograma.map(InstitucionSnp.fromObject);

    const institucionActual: InstitucionSnp | undefined = institucionesFinales.find(
      institucionActual => institucionActual.claveInstitucion == seleccion.institucion?.claveInstitucion
    );
    const sedeActual: SedeSnp | undefined = (institucionActual?.sedes ?? []).find(
      sede => sede.claveDependencia == seleccion.sede?.claveDependencia
    );

    const institucionNueva: InstitucionSnp = seleccion.institucion ?? {};
    institucionNueva.postulante = esPostulante || (institucionActual?.postulante ?? false);

    const sedeNueva: SedeSnp = seleccion.sede ?? {};
    sedeNueva.postulante = esPostulante || (sedeActual?.postulante ?? false);

    if (institucionActual != undefined) {
      institucionActual.activo = institucionNueva.activo;
      institucionActual.claveEntidadFederativa = institucionNueva.claveEntidadFederativa;
      institucionActual.claveInstitucion = institucionNueva.claveInstitucion;
      institucionActual.claveMunicipio = institucionNueva.claveMunicipio;
      institucionActual.clavePais = institucionNueva.clavePais;
      institucionActual.entidadFederativa = institucionNueva.entidadFederativa;
      institucionActual.municipio = institucionNueva.municipio;
      institucionActual.nombreInstitucion = institucionNueva.nombreInstitucion;
      institucionActual.pais = institucionNueva.pais;
      institucionActual.postulante = institucionNueva.postulante;
      institucionActual.reniecyt = institucionNueva.reniecyt;
      institucionActual.rfc = institucionNueva.rfc;
      institucionActual.sector = institucionNueva.sector;

      if (sedeActual != undefined) {
        sedeActual.activo = sedeNueva.activo;
        sedeActual.claveDependencia = sedeNueva.claveDependencia;
        sedeActual.claveEntidadFederativa = sedeNueva.claveEntidadFederativa;
        sedeActual.claveMunicipio = sedeNueva.claveMunicipio;
        sedeActual.clavePais = sedeNueva.clavePais;
        sedeActual.claveSede = sedeNueva.claveSede;
        sedeActual.entidadFederativa = sedeNueva.entidadFederativa;
        sedeActual.esInstitucion = sedeNueva.esInstitucion;
        sedeActual.municipio = sedeNueva.municipio;
        sedeActual.nombreDependencia = sedeNueva.nombreDependencia;
        sedeActual.pais = sedeNueva.pais;
        sedeActual.postulante = sedeNueva.postulante;
        sedeActual.reniecytDependencia = sedeNueva.reniecytDependencia;
        sedeActual.reniecytSede = sedeNueva.reniecytSede;
        sedeActual.sede = sedeNueva.sede;
      } else {
        if (!institucionActual.sedes) {
          institucionActual.sedes = [];
        }
        institucionActual.sedes?.push(sedeNueva);
      }
    } else {
      institucionNueva.sedes = [sedeNueva];
      institucionesFinales.push(institucionNueva);
    }

    return institucionesFinales;
  }

  public mostrarModalEliminarInstitucion(institucion: InstitucionSnp, sede: SedeSnp): void {
    this.institucionEliminar = institucion;
    this.sedeEliminar = sede;
    this.mostrarModalEliminar = true;
  }

  public eliminarInstitucion(): void {
    this.usuarios = this.solicitud.usuarios || [];
    if (!this.institucionEliminar || !this.sedeEliminar || this.sedeEliminar.postulante) {
      return;
    }

    let institucionesFinales: Array<InstitucionSnp> = this.institucionesDelPrograma.map(InstitucionSnp.fromObject);

    const institucionActual: InstitucionSnp | undefined = institucionesFinales.find(
      institucionActual => institucionActual.claveInstitucion == this.institucionEliminar?.claveInstitucion
    );
    const sedeActual: SedeSnp | undefined = (institucionActual?.sedes ?? []).find(
      sede => sede.claveDependencia == this.sedeEliminar?.claveDependencia
    );

    if (!institucionActual || !sedeActual) {
      return;
    }

    if ((institucionActual.sedes?.length ?? 0) > 1) {
      institucionActual.sedes = (institucionActual.sedes ?? []).filter(sede => sede.claveDependencia != sedeActual.claveDependencia);
    } else {
      institucionesFinales = institucionesFinales.filter(institucion => institucion.claveInstitucion != institucionActual.claveInstitucion);
    }

    const clavesInstitucionesFinales: Array<string> = institucionesFinales.map(institucion => institucion.claveInstitucion ?? '');
    const claveInstitucionEliminada: string | undefined = (this.solicitud?.instituciones ?? [])
      .map(institucion => institucion.claveInstitucion ?? '')
      .find(clave => !clavesInstitucionesFinales.includes(clave));

    this.personalBecaService()
      .obtenerPersonalBecasPorInstitucinYRoles(claveInstitucionEliminada ?? '', [
        RolAutoridad.COORDINADOR_INSTITUCIONAL,
        RolAutoridad.ASISTENTE_COORDINADOR_INSTITUCIONAL,
      ])
      .then(res => {
        const usuariosInstitucionEliminada: Array<IUsuarioRol> = res.data.map(personalBeca => UsuarioRol.fromObject(personalBeca));
        const usuariosNuevos = this.usuarios.filter(usuario => !usuariosInstitucionEliminada.some(u => u.cvu === usuario.cvu));
        this.emitirActualizacion(institucionesFinales, usuariosNuevos);
      })
      .catch(error => {
        console.error('Error al obtener personal de becas:', error);
      });
  }

  @Emit('submit')
  public emitirActualizacion(
    instituciones: Array<InstitucionSnp>,
    usuarios: IUsuarioRol[]
  ): { [key: string]: Array<InstitucionSnp> | Array<IUsuarioRol> } {
    return { instituciones: instituciones, usuarios: usuarios };
  }

  get obtenerProgramaFixed(): Programa {
    const programa: Programa = Programa.fromObject(this.solicitud?.programa ?? new Programa());
    programa.instituciones = (this.solicitud?.instituciones ?? []).map(InstitucionSnp.fromObject);
    return programa;
  }

  get mostrarAccionNueva(): boolean {
    return (
      (!['DOBTIT', 'UNISD'].includes(this.caracteristica.cveCaracteristica ?? '---') || this.institucionesDelPrograma.length == 0) &&
      !!this.caracteristica.cveCaracteristica
    );
  }
}
